import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getPharmacySuppliers } from 'app/entities/pharmacy-suppliers/pharmacy-suppliers.reducer';
import { getEntities as getTenantEmployees } from 'app/entities/tenant-employee/tenant-employee.reducer';
import { getEntities as getPharmacyStockBills } from 'app/entities/pharmacy-stock-bill/pharmacy-stock-bill.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-stock-bill.reducer';

export const PharmacyStockBillUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const pharmacySuppliers = useAppSelector(state => state.pharmacySuppliers.entities);
  const tenantEmployees = useAppSelector(state => state.tenantEmployee.entities);
  const pharmacyStockBills = useAppSelector(state => state.pharmacyStockBill.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const pharmacyStockBillEntity = useAppSelector(state => state.pharmacyStockBill.entity);
  const loading = useAppSelector(state => state.pharmacyStockBill.loading);
  const updating = useAppSelector(state => state.pharmacyStockBill.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyStockBill.updateSuccess);
  const pharmacyAddedByTypeValues = Object.keys(PharmacyAddedByType);

  const handleClose = () => {
    navigate(`/pharmacy-stock-bill${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacies({}));
    dispatch(getPharmacySuppliers({}));
    dispatch(getTenantEmployees({}));
    dispatch(getPharmacyStockBills({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.billDate !== undefined && typeof values.billDate !== 'number') {
      values.billDate = Number(values.billDate);
    }
    if (values.totalCost !== undefined && typeof values.totalCost !== 'number') {
      values.totalCost = Number(values.totalCost);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cgst !== undefined && typeof values.cgst !== 'number') {
      values.cgst = Number(values.cgst);
    }
    if (values.sgst !== undefined && typeof values.sgst !== 'number') {
      values.sgst = Number(values.sgst);
    }
    if (values.roundOffVal !== undefined && typeof values.roundOffVal !== 'number') {
      values.roundOffVal = Number(values.roundOffVal);
    }
    if (values.margin !== undefined && typeof values.margin !== 'number') {
      values.margin = Number(values.margin);
    }
    if (values.cessAmount !== undefined && typeof values.cessAmount !== 'number') {
      values.cessAmount = Number(values.cessAmount);
    }
    if (values.statusDate !== undefined && typeof values.statusDate !== 'number') {
      values.statusDate = Number(values.statusDate);
    }
    if (values.receivedDate !== undefined && typeof values.receivedDate !== 'number') {
      values.receivedDate = Number(values.receivedDate);
    }

    const entity = {
      ...pharmacyStockBillEntity,
      ...values,
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
      pharmacySuppliers: pharmacySuppliers.find(it => it.id.toString() === values.pharmacySuppliers?.toString()),
      pharmacist: tenantEmployees.find(it => it.id.toString() === values.pharmacist?.toString()),
      amendedFrom: pharmacyStockBills.find(it => it.id.toString() === values.amendedFrom?.toString()),
      amendedTo: pharmacyStockBills.find(it => it.id.toString() === values.amendedTo?.toString()),
      invoiceType: clinicalDictionaries.find(it => it.id.toString() === values.invoiceType?.toString()),
      approvalStatus: clinicalDictionaries.find(it => it.id.toString() === values.approvalStatus?.toString()),
      statusSettingPharmacy: pharmacies.find(it => it.id.toString() === values.statusSettingPharmacy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          addedByType: 'PHARMACY',
          modifiedByType: 'PHARMACY',
          ...pharmacyStockBillEntity,
          pharmacy: pharmacyStockBillEntity?.pharmacy?.id,
          pharmacySuppliers: pharmacyStockBillEntity?.pharmacySuppliers?.id,
          pharmacist: pharmacyStockBillEntity?.pharmacist?.id,
          amendedFrom: pharmacyStockBillEntity?.amendedFrom?.id,
          amendedTo: pharmacyStockBillEntity?.amendedTo?.id,
          invoiceType: pharmacyStockBillEntity?.invoiceType?.id,
          approvalStatus: pharmacyStockBillEntity?.approvalStatus?.id,
          statusSettingPharmacy: pharmacyStockBillEntity?.statusSettingPharmacy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyStockBill.home.createOrEditLabel" data-cy="PharmacyStockBillCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.home.createOrEditLabel">Create or edit a PharmacyStockBill</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-stock-bill-id"
                  label={translate('tinyMedicRestApp.pharmacyStockBill.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.billNumber')}
                id="pharmacy-stock-bill-billNumber"
                name="billNumber"
                data-cy="billNumber"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.billDate')}
                id="pharmacy-stock-bill-billDate"
                name="billDate"
                data-cy="billDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.totalCost')}
                id="pharmacy-stock-bill-totalCost"
                name="totalCost"
                data-cy="totalCost"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.discount')}
                id="pharmacy-stock-bill-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.active')}
                id="pharmacy-stock-bill-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.cursor')}
                id="pharmacy-stock-bill-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.timestampentry')}
                id="pharmacy-stock-bill-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.microSec')}
                id="pharmacy-stock-bill-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.lastupdated')}
                id="pharmacy-stock-bill-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.cgst')}
                id="pharmacy-stock-bill-cgst"
                name="cgst"
                data-cy="cgst"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.sgst')}
                id="pharmacy-stock-bill-sgst"
                name="sgst"
                data-cy="sgst"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.roundOffVal')}
                id="pharmacy-stock-bill-roundOffVal"
                name="roundOffVal"
                data-cy="roundOffVal"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.shipmentId')}
                id="pharmacy-stock-bill-shipmentId"
                name="shipmentId"
                data-cy="shipmentId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.addedById')}
                id="pharmacy-stock-bill-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.modifiedById')}
                id="pharmacy-stock-bill-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.addedByType')}
                id="pharmacy-stock-bill-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.modifiedByType')}
                id="pharmacy-stock-bill-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.margin')}
                id="pharmacy-stock-bill-margin"
                name="margin"
                data-cy="margin"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.cessAmount')}
                id="pharmacy-stock-bill-cessAmount"
                name="cessAmount"
                data-cy="cessAmount"
                type="text"
              />
              <UncontrolledTooltip target="cessAmountLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.help.cessAmount" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.amended')}
                id="pharmacy-stock-bill-amended"
                name="amended"
                data-cy="amended"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="amendedLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyStockBill.help.amended" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.statusDate')}
                id="pharmacy-stock-bill-statusDate"
                name="statusDate"
                data-cy="statusDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockBill.receivedDate')}
                id="pharmacy-stock-bill-receivedDate"
                name="receivedDate"
                data-cy="receivedDate"
                type="text"
              />
              <ValidatedField
                id="pharmacy-stock-bill-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacyStockBill.pharmacy')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-stock-bill-pharmacySuppliers"
                name="pharmacySuppliers"
                data-cy="pharmacySuppliers"
                label={translate('tinyMedicRestApp.pharmacyStockBill.pharmacySuppliers')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacySuppliers
                  ? pharmacySuppliers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-stock-bill-pharmacist"
                name="pharmacist"
                data-cy="pharmacist"
                label={translate('tinyMedicRestApp.pharmacyStockBill.pharmacist')}
                type="select"
              >
                <option value="" key="0" />
                {tenantEmployees
                  ? tenantEmployees.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-stock-bill-amendedFrom"
                name="amendedFrom"
                data-cy="amendedFrom"
                label={translate('tinyMedicRestApp.pharmacyStockBill.amendedFrom')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyStockBills
                  ? pharmacyStockBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-stock-bill-amendedTo"
                name="amendedTo"
                data-cy="amendedTo"
                label={translate('tinyMedicRestApp.pharmacyStockBill.amendedTo')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyStockBills
                  ? pharmacyStockBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-stock-bill-invoiceType"
                name="invoiceType"
                data-cy="invoiceType"
                label={translate('tinyMedicRestApp.pharmacyStockBill.invoiceType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-stock-bill-approvalStatus"
                name="approvalStatus"
                data-cy="approvalStatus"
                label={translate('tinyMedicRestApp.pharmacyStockBill.approvalStatus')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-stock-bill-statusSettingPharmacy"
                name="statusSettingPharmacy"
                data-cy="statusSettingPharmacy"
                label={translate('tinyMedicRestApp.pharmacyStockBill.statusSettingPharmacy')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-stock-bill" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyStockBillUpdate;
